import { render, staticRenderFns } from "./CzTag.vue?vue&type=template&id=5f64a49c&scoped=true&"
import script from "./CzTag.vue?vue&type=script&lang=ts&"
export * from "./CzTag.vue?vue&type=script&lang=ts&"
import style0 from "./CzTag.vue?vue&type=style&index=0&id=5f64a49c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f64a49c",
  null
  
)

export default component.exports